var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('strong',[_vm._v("Copyright © 2019 "),_c('a',{attrs:{"href":"https://agencialink.com"}},[_vm._v("AgenciaLink.com")]),_vm._v(".")])])
}]

export { render, staticRenderFns }